import { useState } from 'react';
import { createPortal } from 'react-dom';
import { createCustomCardTypeCategory } from '../../../../../../utils/firebase/checklist';

import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalBody,
  ModalFooter,
  ButtonGroup,
  CreateButton,
  CancelButton,
  InputContainer,
  ErrorContainer
} from './CreateCardTypeCategoryModal.styles';

// components
import CriticalMessage from '../../../../../../components/system/critical-message/CriticalMessage';
import InputBar from '../../../../../../components/input-bar/InputBar';

export default function CreateCardTypeCategoryModal({ 
  isOpen, 
  onClose,
  user,
  sport,
  year,
  manufacturer,
  series,
  cardType,
  onCategoryCreated
}) {
  const [categoryName, setCategoryName] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    setCategoryName('');
    setError('');
    setIsCreating(false);
    onClose();
  };

  const handleCreate = async () => {
    if (!categoryName.trim()) {
      setError('Category name is required');
      return;
    }

    if (!user?.uid) {
      setError('You must be logged in to create a custom category');
      return;
    }

    setIsCreating(true);
    setError('');

    try {
      const createdCategory = await createCustomCardTypeCategory(
        user.uid,
        sport,
        year,
        manufacturer,
        series,
        cardType,
        categoryName
      );

      // Call the callback to refresh categories
      if (onCategoryCreated) {
        onCategoryCreated(createdCategory);
      }

      handleClose();
    } catch (err) {
      console.error('Error creating category:', err);
      setError(err.message || 'Failed to create category. Please try again.');
      setIsCreating(false);
    }
  };

  if (!isOpen) return null;

  const modalContent = (
    <ModalOverlay onClick={handleClose} className='widget-bg'>
      <ModalContainer onClick={(e) => e.stopPropagation()} className='panel-bg'>
        <ModalHeader>
          <ModalTitle>Create New Card Type Category</ModalTitle>
          <CloseButton onClick={handleClose}>×</CloseButton>
        </ModalHeader>

        <ModalBody>
          <InputContainer>
            <InputBar
              type="text"
              label="Category Name"
              value={categoryName}
              updateValue={setCategoryName}
              id="category-name-input"
            />
          </InputContainer>
          {error && (
            <>
            <h1>HI</h1>
            <ErrorContainer>
              <CriticalMessage text={error} color='red' />
            </ErrorContainer>
            </>
          )}
        </ModalBody>

        <ModalFooter>
          <ButtonGroup>
            <CreateButton 
              onClick={handleCreate}
              disabled={!categoryName.trim() || isCreating}
            >
              {isCreating ? 'Creating...' : 'Create'}
            </CreateButton>
            <CancelButton onClick={handleClose} disabled={isCreating}>
              Cancel
            </CancelButton>
          </ButtonGroup>
        </ModalFooter>
      </ModalContainer>
    </ModalOverlay>
  );

  return createPortal(modalContent, document.body);
}

